import 'leaflet';
import 'leaflet/dist/leaflet.css';
//import { validate } from 'webpack';
//import { MBTiles, mbtiles } from 'leaflet-tilelayer-mbtiles-ts';
import '../css/App.css';

$(document).ready(function() {

    var map = new L.Map("map", {
        center: new L.LatLng(47.0349968, 4.9241846),
        zoom: 6,
        zoomControl: false
        });

    L.control.zoom({
        position: 'topright'
    }).addTo(map);


//Definition des différents layers
const overlays = new L.FeatureGroup();

const osm = L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
    maxZoom: 22,
    maxNativeZoom: 19,
    continuousWorld: true,
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>',
    id: 'osm'
}).addTo(map);

//Definition de la carte
map.createPane("pane240").style.zIndex = 240; // between tiles and overlays
map.createPane("pane250").style.zIndex = 250; // between tiles and overlays
map.createPane("pane255").style.zIndex = 255; // between tiles and overlays
map.createPane("pane260").style.zIndex = 260; // between tiles and overlays
map.createPane("pane270").style.zIndex = 270; // between tiles and overlays
map.createPane("pane280").style.zIndex = 280; // between tiles and overlays
map.createPane("pane450").style.zIndex = 450; // between overlays and shadows
map.createPane("pane620").style.zIndex = 620; // between markers and tooltips
map.createPane("pane800").style.zIndex = 800; // above popups

function infoAA (feature, layer) {
    const properties = feature.properties;
    const popup = L.popup({
        closeButton: true
    }).setContent("<table class='table table-striped table-bordered table-condensed'>" +
        "<h5> Informations de la couche " +layer.options.name+ ": </h5> " +
        "<tr><th>Nom de l'aire urbaine &nbsp;</th><td>" + properties.Data_standardise_AIRES_ATTRACTION_VILLES + "</td></tr>" +
        "<tr><th>Population 2017 de l'aire urbaine &nbsp;</th><td>" + properties.aav2020_pop_aav2017 + "</td></tr>" +
        "<table>");
    layer.bindPopup(popup);
    layer.openPopup();
}

function infoZDC (feature, layer) {
    const properties = feature.properties;
    const popup = L.popup({
        closeButton: true
    }).setContent("<table class='table table-striped table-bordered table-condensed'>" +
        "<h5> Informations de la couche " +layer.options.name+ ": </h5> " +
        "<tr><th>Population de la zone de chalandise :</th><td>" + layer.feature.properties.Agregation_Carreaux_dans_ZDC_PDV_JourDeFete_OSM_Simplifie_est_pop + "</td></tr>" +
        "<table>");
    layer.bindPopup(popup);
    layer.openPopup();
}

function infoZDC30 (feature, layer) {
    const properties = feature.properties;
    const popup = L.popup({
        closeButton: true
    }).setContent("<table class='table table-striped table-bordered table-condensed'>" +
        "<h5> Informations de la couche " +layer.options.name+ ": </h5> " +
        "<tr><th>Population de la zone de chalandise :</th><td>" + layer.feature.properties.Agregation_Carreaux_dans_ZDC_PDV_30min_JourDeFete_OSM_Simplifie_est_pop + "</td></tr>" +
        "<table>");
    layer.bindPopup(popup);
    layer.openPopup();
}

function infoZT20 (feature, layer) {
    const properties = feature.properties;
    const popup = L.popup({
        closeButton: true
    }).setContent("<table class='table table-striped table-bordered table-condensed'>" +
        "<h5> Informations de la couche " +layer.options.name+ ": </h5> " +
        "<tr><th>Nom:</th><td>" + layer.feature.properties.Nom + "</td></tr>" +
        "<tr><th>Nom abrégé :</th><td>" + layer.feature.properties.colonne_1 + "</td></tr>" +
        "<tr><th>Ville :</th><td>" + layer.feature.properties.Ville + "</td></tr>" +
        "<tr><th>Code postal :</th><td>" + layer.feature.properties.Code_posta + "</td></tr>" +
        "<tr><th>Type d'implantation :</th><td>" + layer.feature.properties.Type_imp + "</td></tr>" +
        "<table>");
    layer.bindPopup(popup);
    layer.openPopup();
}

function onEachFeaturePDVJDF(feature, layer){
    var popup = L.popup({
        closeButton: true
    }).setContent("<table class='table table-striped table-bordered table-condensed'>" +
    "<h5> Informations de la couche points de vente Jour de Fête :</h5> " +
        "<tr><th>Nom:</th><td>" + layer.feature.properties.Nom + "</td></tr>" +
        "<tr><th>Adresse :</th><td>" + layer.feature.properties.Adresse + "</td></tr>" +
        "<tr><th>Ville :</th><td>" + layer.feature.properties.Ville + "</td></tr>" +
        "<tr><th>Code postal :</th><td>" + layer.feature.properties.Code_posta + "</td></tr>" +
        "<tr><th>Type d'implantation :</th><td>" + layer.feature.properties.Type_d_imp + "</td></tr>" +
        "<table>");
    layer.bindPopup(popup);
}

function onEachFeaturePDVC(feature, layer){
    var popup = L.popup({
        closeButton: true
    }).setContent("<table class='table table-striped table-bordered table-condensed'>" +
    "<h5> Informations de la couche Big 4 :</h5> " +
        "<tr><th>Nom du Big 4:</th><td>" + layer.feature.properties.Concurrent + "</td></tr>" +
        "<tr><th>Adresse :</th><td>" + layer.feature.properties.Adresse + "</td></tr>" +
        "<tr><th>Ville :</th><td>" + layer.feature.properties.Ville + "</td></tr>" +
        "<tr><th>Code postal :</th><td>" + layer.feature.properties.Code_posta + "</td></tr>" +
        "<table>");
    layer.bindPopup(popup);
}

function onEachFeaturePDVI(feature, layer){
    var popup = L.popup({
        closeButton: true
    }).setContent("<table class='table table-striped table-bordered table-condensed'>" +
    "<h5> Informations de la couche Indépendants :</h5> " +
        "<tr><th>Nom:</th><td>" + layer.feature.properties.NOM+ "</td></tr>" +
        "<tr><th>Ville :</th><td>" + layer.feature.properties.VILLE + "</td></tr>" +
        "<tr><th>Adresse :</th><td>" + layer.feature.properties.ADRESSE + "</td></tr>" +
        "<tr><th>Typologie d'emplacement :</th><td>" + layer.feature.properties.typo_empla + "</td></tr>" +
        "<table>");
    layer.bindPopup(popup);
}

function infoFidel(feature, layer){
    var popup = L.popup({
        closeButton: true
    }).setContent("<table class='table table-striped table-bordered table-condensed'>" +
    "<h5> Informations sur les fidélisés du magasin :</h5> " +
        "<tr><th>Code postal :</th><td>" + layer.feature.properties.ID+ "</td></tr>" +
        "<tr><th>Libellé :</th><td>" + layer.feature.properties.LIB + "</td></tr>" +
        "<tr><th>Nombre de clients fidélisés du magasin :</th><td>" + layer.feature.properties.NUMPOINTS + "</td></tr>" +
        "<tr><th>Part des fidélisés de la zone / total des fidélisés du magasin :</th><td>" + layer.feature.properties.pourc_nump + " % </td></tr>" +
        "<table>");
    layer.bindPopup(popup);
    function customTip() {
        this.unbindTooltip();
        if(!this.isPopupOpen()) this.bindTooltip('<p>Nombre de clients fidélisés du magasin : </th><td>'+layer.feature.properties.NUMPOINTS+'<p/>'+
        '<p>Part des fidélisés de la zone / total des fidélisés du magasin : '+layer.feature.properties.pourc_nump+' %<p/>').openTooltip();
    }
    //const tooltip = layer.bindTooltip("my tooltip",{permanent:'true'});
    layer.on('mouseover', customTip);

}

//AA

    const AiresUrbaines = L.geoJson(AiresUrb,{
        color: "purple",
        fillColor: "purple",
        fillOpacity: 0.2,
        weight: 2,
        zIndex: 0,
        pane: "pane250",
        name: 'Aires urbaines',
        onEachFeature: infoAA
    });
    AiresUrbaines.name = 'AiresUrbaines';
    overlays.addLayer(AiresUrbaines);
    //AiresUrbaines.bringToBack();

//ZDC 20 min JDF
	
    const ZDC = L.geoJson(ZDC_JDF,{
        /*color: "black",
        fillColor: "blue",
        fillOpacity: 0.2,
        weight: 0.4,*/
        color: "blue",
        fillColor: "blue",
        fillOpacity: 0.1,
        weight: 3,
        zIndex: 10,
        pane: "pane240",
        name: 'Zone de chalandise à 20 min Jour de Fête',
        onEachFeature: infoZDC
    }); 
    ZDC.name = 'ZDC';
    overlays.addLayer(ZDC);
    //communes.bringToFront();

//ZDC 30 min JDF
	
const ZDC30 = L.geoJson(ZDC30_JDF,{
    /*color: "black",
    fillColor: "steelblue",
    fillOpacity: 0.6,
    weight: 0.4,*/
    color: "steelblue",
    fillColor: "steelblue",
    fillOpacity: 0.1,
    weight: 3,
    zIndex: 10,
    pane: "pane240",
    name: 'Zone de chalandise à 30 min Jour de Fête',
    onEachFeature: infoZDC30
}); 
ZDC30.name = 'ZDC30';
overlays.addLayer(ZDC30);
//communes.bringToFront();

//ZDC 30 min JDF
	
const ZT20 = L.geoJson(ZT20_JDF,{
    color: "red",
    fillColor: "none",
    fillOpacity: 0.6,
    weight: 2,
    zIndex: 10,
    pane: "pane280",
    name: 'Zone tampon à 20 Km Jour de Fête',
    onEachFeature: infoZT20
}); 
ZT20.name = 'ZT20';
overlays.addLayer(ZT20);
//communes.bringToFront();

//PDV JDF
var MarkerPDVJDF = {
    radius: 6,
    fillColor: "red",
    color: "black",
    weight: 0.4,
    opacity: 1,
    fillOpacity: 1
};

const PDV_JDF = L.geoJSON(PDVJDF, {
    zIndex: 30,
    pane: "pane450",
    onEachFeature: onEachFeaturePDVJDF,
    pointToLayer: function (feature, latlng) {
        return L.circleMarker(latlng, MarkerPDVJDF);
    }
});
PDV_JDF.name = 'PDV_JDF';
overlays.addLayer(PDV_JDF);

//Clients fidelite par magasins

function getColor(d) {
    return d > 5000 ? '#800026' :
           d > 2000  ? '#BD0026' :
           d > 500  ? '#E31A1C' :
           d > 100  ? '#FC4E2A' :
           d > 50   ? '#FD8D3C' :
           d > 20   ? '#FEB24C' :
           d > 5   ? '#FED976' :
           'none';
                      //'#FFEDA0';
}

function style(feature) {
    return {
        fillColor: getColor(feature.properties.NUMPOINTS),
        weight: 0.5,
        opacity: 1,
        color: 'white',
        dashArray: '3',
        fillOpacity: 0.6
    };
}

const fidel_AMI = L.geoJSON(fidelAMI, {
    pane: "pane255",
    name: 'Nombre de clients du magasin fidélisés',
    style: style,
    onEachFeature: infoFidel
}); 
fidel_AMI.name = 'fidel_AMI';
overlays.addLayer(fidel_AMI);

const fidel_ARR = L.geoJSON(fidelARR, {
    pane: "pane255",
    name: 'Nombre de clients du magasin fidélisés',
    style: style,
    onEachFeature: infoFidel
}); 
fidel_ARR.name = 'fidel_ARR';
overlays.addLayer(fidel_ARR);

const fidel_BOU = L.geoJSON(fidelBOU, {
    pane: "pane255",
    name: 'Nombre de clients du magasin fidélisés',
    style: style,
    onEachFeature: infoFidel
}); 
fidel_BOU.name = 'fidel_BOU';
overlays.addLayer(fidel_BOU);

const fidel_GAP = L.geoJSON(fidelGAP, {
    pane: "pane255",
    name: 'Nombre de clients du magasin fidélisés',
    style: style,
    onEachFeature: infoFidel
}); 
fidel_GAP.name = 'fidel_GAP';
overlays.addLayer(fidel_GAP);

const fidel_MDM = L.geoJSON(fidelMDM, {
    pane: "pane255",
    name: 'Nombre de clients du magasin fidélisés',
    style: style,
    onEachFeature: infoFidel
}); 
fidel_MDM.name = 'fidel_MDM';
overlays.addLayer(fidel_MDM);

const fidel_SMA = L.geoJSON(fidelSMA, {
    pane: "pane255",
    name: 'Nombre de clients du magasin fidélisés',
    style: style,
    onEachFeature: infoFidel
}); 
fidel_SMA.name = 'fidel_SMA';
overlays.addLayer(fidel_SMA);

const fidel_VAR = L.geoJSON(fidelVAR, {
    pane: "pane255",
    name: 'Nombre de clients du magasin fidélisés',
    style: style,
    onEachFeature: infoFidel
}); 
fidel_VAR.name = 'fidel_VAR';
overlays.addLayer(fidel_VAR);

//Big 4

var MarkerPDVC = {
    radius: 5,
    fillColor: "yellow",
    color: "black",
    weight: 0.4,
    opacity: 1,
    fillOpacity: 1
};

const PDV_C = L.geoJSON(concurrents, {
    zIndex: 30,
    pane: "pane620",
    onEachFeature: onEachFeaturePDVC,
    pointToLayer: function (feature, latlng) {
        return L.circleMarker(latlng, MarkerPDVC);
    }
});
PDV_C.name = 'PDV_C';
overlays.addLayer(PDV_C);

//Independants

var MarkerPDVI = {
    radius: 4,
    fillColor: "orange",
    color: "black",
    weight: 0.4,
    opacity: 1,
    fillOpacity: 1
};

const PDV_I = L.geoJSON(independants, {
    zIndex: 30,
    pane: "pane800",
    onEachFeature: onEachFeaturePDVI,
    pointToLayer: function (feature, latlng) {
        return L.circleMarker(latlng, MarkerPDVI);
    }
});
PDV_I.name = 'PDV_I';
overlays.addLayer(PDV_I);

/*mbtiles = mbtiles('../assets/test_tiles.mbtiles');
    
    mbtiles.addTo(map);*/

var legend = L.control({position: 'bottomright'});

legend.onAdd = function (map) {

    var div = L.DomUtil.create('div', 'info legend'),
        grades = [5, 20, 50, 100, 500, 2000, 5000],
        labels = [];
div.innerHTML='<p>>Nb de fidélisés :</p> ';
    // loop through our density intervals and generate a label with a colored square for each interval
    for (var i = 0; i < grades.length; i++) {
        div.innerHTML +=
            '<i style="background:' + getColor(grades[i] + 1) + '"></i> ' +
            grades[i] + (grades[i + 1] ? '&ndash;' + grades[i + 1] + '<br>' : '+');
    }

    return div;
};

legend.addTo(map);

//Contrôle des couches

    $("input[name='overlays']").on('click', function(e) {
        e.stopPropagation();
        const idCheckbox=$(this).attr('id');
        //On boucle dans les overlays pour sélectionner la couche à afficher en fonction de la checkbox cliquée
        overlays.eachLayer(layer => {
            if(layer.name==idCheckbox){
                if (map.hasLayer(layer)) {
                    map.removeLayer(layer);
                } else {
                    map.addLayer(layer);
                }
            }  
        });
    });


});